import { IonPage } from "@ionic/react";
import { YourMissionOnboardingContent } from "@/components/YourMission/OnboardingContent";
import { YourMissionContent } from "@/components/YourMission/YourMissionContent";
import { useMyData } from "@/lib/query/functions/user/data";

export function YourMission() {
	const [myData] = useMyData();

	return (
		<IonPage>
			{myData.modal.yourMissionExplainer.seen ? (
				<YourMissionContent />
			) : (
				<YourMissionOnboardingContent />
			)}
		</IonPage>
	);
}
